import { gql } from '@apollo/client';

export const GET_GLOBAL_CONFIGURATION = gql`
  query GetGlobalConfig($affiliateName: String!) {
    getGlobalConfig(affiliateName: $affiliateName) {
      affiliateName
      globalConfig
      realm
    }
  }
`;

export const GET_APP_CONFIGURATION = gql`
  query GetAppConfig($affiliateName: String!) {
    getAppConfig(affiliateName: $affiliateName) {
      appConfig
    }
  }
`;

export const GET_MENU_ITEMS = gql`
  query getAppMenuConfig {
    getAppMenuConfig {
      id
      icon: iconUrl
      inactiveIcon: inactiveIconUrl
      name
      route: routeUrl
      subMenuItems {
        id
        icon: iconUrl
        category: name
        route: routeUrl
      }
    }
  }
`;
